export const FETCH_ITEM_TYPES = 'FETCH_ITEM_TYPES';
export const FETCHING_ITEM_TYPES = 'FETCHING_ITEM_TYPES';
export const FETCH_ITEM_TYPES_SUCCESS = 'FETCH_ITEM_TYPES_SUCCESS';
export const FETCH_ITEM_TYPES_FAILED = 'FETCH_ITEM_TYPES_FAILED';

// export const FETCH_ITEM = 'FETCH_ITEM';
// export const FETCHING_ITEM = 'FETCHING_ITEM';
// export const FETCH_ITEM_SUCCESS = 'FETCH_ITEM_SUCCESS';
// export const FETCH_ITEM_FAILED = 'FETCH_ITEM_FAILED';

export function fetchItemTypes() {
  return {
    type: FETCH_ITEM_TYPES,
  };
}

export function fetchingItemTypes() {
  return {
    type: FETCHING_ITEM_TYPES,
  };
}

export function fetchItemTypesSuccess(itemTypes) {
  return {
    type: FETCH_ITEM_TYPES_SUCCESS,
    itemTypes,
  };
}

export function fetchItemTypesFailed(err) {
  return {
    type: FETCH_ITEM_TYPES_FAILED,
    message: err.message,
  };
}

// export function fetchItem(itemId) {
//   return {
//     type: FETCH_ITEM,
//     itemId,
//   };
// }
//
// export function fetchingItem(itemId) {
//   return {
//     type: FETCHING_ITEM,
//     itemId,
//   };
// }
//
// export function fetchItemSuccess(item) {
//   return {
//     type: FETCH_ITEM_SUCCESS,
//     item,
//   };
// }
//
// export function fetchItemFailed(itemId,err) {
//   return {
//     type: FETCH_ITEM_FAILED,
//     itemId,
//     message: err.message,
//   };
// }



// WEBPACK FOOTER //
// ./src/actions/itemtypes.js